import React, { Component } from "react";
import { Button, PageHeader, DropdownButton, MenuItem, ListGroup, ListGroupItem, Row, Col } from "react-bootstrap";
import { Link, Routes }            from 'react-router-dom'
import RenderLander                from "../../components/utils/RenderLander";
import FooterLoadingBar            from "../../components/utils/FooterLoadingBar";
import YouTubePlayer               from "../../components/YouTubePlayer";
import { handleGoToURL}            from "../../utils/URL";
import { invokeSetDeleteExercise } from "../../utils/AwsInvoke";
import { createHTMLMarkup }        from "../../utils/HTML";
import "../../css/help/HelpDetail.css";

import { invokeGetHelpDetail} from "../../utils/AwsInvoke";

// uuidv1() = timestamp | uuidv4() = rnadom
const uuidv1 = require('uuid/v1');

export default class HelpDetail extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: true,
            helpId: `${this.props.match.params.help_id}`,
            showLoadingBar:"none",
        };
    }

    componentDidMount() {
        var help_id = this.state.helpId;

        if(help_id != undefined) {
            this.getHelpDetailData(help_id);
        }
    }

    getHelpDetailData = async (help_id) => {

        if(help_id != "undefined") {
                this.setState({
                    loadingData: "Loading Help data ... "
                })
                const results = await invokeGetHelpDetail(help_id);

                if(results) {
                    var youtube_id  = results[0].youtube_id;
                    var question    = results[0].question;
                    var answer      = results[0].answer;

                    this.setState({
                        youtubeId: youtube_id,
                        answer:    answer,
                        question:  question,
                        isLoading: false
                    });

                    this.msgDataLoaded();
                } else {
                    this.msgDataLoaded();

                }
        }
    }

    msgDataLoaded = () => {
        this.setState({
            loadingData: "", isLoading: false, showLoadingBar: "none"
        })
    }

    renderPrograms() {

        var youtube_id     = this.state.youtubeId;
        var youtube_player = "";

        if(youtube_id != null && youtube_id != "")
           youtube_player = <span>
                                  <div className="helpYouTubeContainer">
                                       <YouTubePlayer yt_id={youtube_id} />
                                   </div>
                                   <div className="helpVerticalSpacer"/>
                            </span>

        return (

              <div className="programs">
                  <PageHeader>
                          Help Detail
                  </PageHeader>
                  <span style={{display:"inline-block", width:"100%"}}>
                      <div>
                          { youtube_player }
                      </div>
                      <div className="helpDetailQuestionText">
                          { this.state.question }
                      </div>
                      <br/>
                      <div className="helpDetailAnswerText">
                          { /*}<div dangerouslySetInnerHTML={createHTMLMarkup( this.state.answer )} /> */ }
                          <textarea className = "helpListDetails"
                                    rows      = { 40 }
                                    value     = { this.state.answer }
                                    readOnly
                                 />
                      </div>
                  </span>
              </div>
        );
    }

    render() {

        return (
              <div className="ProgramList">
                {this.props.isAuthenticated ? this.renderPrograms() : <RenderLander /> }

                <FooterLoadingBar text={"Retrieving Help data ..."}
                                  showLoadingBar={this.state.showLoadingBar}/>
              </div>
        );
  }
}



// WEBPACK FOOTER //
// ./src/screens/help/HelpDetail.js